import React, { useState, useEffect, useContext } from 'react';
import Header from '../Header/AppHeader';
import Axiosfetch from '../Common/Axiosfetch';
import baseURL from '../Common/Config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faMapMarkerAlt, faBoxOpen, faEye, faPhoneVolume, faWallet,
    faPrint, faRandom, faHandHoldingUsd, faPlus, faThumbsUp, faSyncAlt,
    faHandHoldingMedical, faCoins, faUsers, faTimes, faMinus, faFileSignature, faFileInvoice,
    faFileAlt,
    faTruck,
    faTruckLoading,
    faCheck,
    faArrowLeft,
    faUserCheck,
    faBell
} from '@fortawesome/free-solid-svg-icons';
import FailureAlert from '../Common/Failure';
import moment from 'moment';
import { ThemeContext } from '../Common/ThemeProvider';
import VehicleChart from '../Common/VehicleChart';
import Alert from 'react-s-alert';
import Select from 'react-select';
import { FetchUsers } from '../Common/Services/UserService';
import PickNTrackPattern from '../../Images/Dashboard_theme.jpg';
import UserDirectory from './UserDirectory';
import UserAlerts from './UserAlerts';

const rewards = {
    Points: 0,
    CreditDate: new Date(),
    CreditTo: "",
    RequestType: 0,
    Type: 0,
    IsTransfer: 0,
    Remarks: ""
};

const quotereply = {
    Amount: 0,
    Remarks: ""
};

const RequestType = [
    { label: "Purchase", value: 1 },
    { label: "Request", value: 2 }
]

const PartnerDashBoard = () => {
    const { CurrentTheme } = useContext(ThemeContext);
    const [PartnerEnquiry, setPartnerEnquiry] = useState([]);
    const [PartnerSurvey, setPartnerSurvey] = useState([]);
    const [SelectedPartnerSurvey, setSelectedPartnerSurvey] = useState({});
    const [SelectedPartnerGoods, setSelectedPartnerGoods] = useState([]);
    const [displayPartnerSurveyView, setdisplayPartnerSurveyView] = useState("none");
    const [displayPartnerGoodsView, setdisplayPartnerGoodsView] = useState("none");
    const [displayAddRewardModel, setdisplayAddRewardModel] = useState("none");
    const [displayBorrowRequest, setdisplayBorrowRequest] = useState("none");
    const [TotalPartnerCFT, setTotalPartnerCFT] = useState(0);
    const [PartnerVehicleRequired, setPartnerVehicleRequired] = useState("NA");
    const [PartnerAdminAlert, setPartnerAdminAlert] = useState({});
    const [Rewards, setRewards] = useState([]);
    const [AddRewardData, setAddRewardData] = useState(rewards);
    const [ActivityOption, setActivityOption] = useState(0);
    const [TransferUsers, setTransferUsers] = useState([]);
    const [Wallet, setWallet] = useState({});
    const [BorrowRequest, setBorrowRequest] = useState([]);
    const [Leads, setLeads] = useState([]);
    const [Quotes, setQuotes] = useState([]);
    const [Dlvrs, setDlvrs] = useState([]);
    const [SelectedLeads, setSelectedLeads] = useState({});
    const [SelectedQuotes, setSelectedQuotes] = useState({});
    const [SelectedDlvrs, setSelectedDlvrs] = useState({});
    const [IntServLeadFlag, setIntServLeadFlag] = useState(0);
    const [IntServQuoteFlag, setIntServQuoteFlag] = useState(0);
    const [IntServDlvrFlag, setIntServDlvrFlag] = useState(0);
    const [LogoImage, setLogoImage] = useState(null);
    const [ShowLogs, setShowLogs] = useState(false);
    const [QuoteReply, setQuoteReply] = useState(false);
    const [DlvrReply, setDlvrReply] = useState(false);
    const [DlvrTerms, setDlvrTerms] = useState(false);
    const [DlvrAdditionalInfo, setDlvrAdditionalInfo] = useState(false);
    const [AddQuoteReply, setAddQuoteReply] = useState(quotereply);
    const [AddDlvrReply, setAddDlvrReply] = useState(quotereply);
    const [LeadsType, setLeadsType] = useState(1);
    const [QuotesType, setQuotesType] = useState(1);
    const [DlvrsType, setDlvrType] = useState(1);
    const [UserDirShow, setUserDirShow] = useState(false);
    const [UserAlertShow, setUserAlertShow] = useState(false);

    useEffect(() => {
        FetchEnquiry();
        FetchAlertInfo();
        FetchUsersData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const FetchEnquiry = () => {
        var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
        Axiosfetch(baseURL + "GetEnquiriesByOrgAndStatus", "POST", { Status: 2, PartnerID: userData.OrganizationID }, EnquiryDataSuccess, Failure);
    };

    const EnquiryDataSuccess = (data) => {
        if (data.length > 0) {
            setPartnerEnquiry(data);
        }
        else {
            setPartnerEnquiry([]);
        }

        FetchSurvey();
    };

    const FetchUsersData = () => {
        FetchUsers(null, UserSuccess, Failure);
    };

    const onNumberChange = (e) => {
        let value = e.target.value === "" ? 0 : parseFloat(e.target.value);
        setAddRewardData({ ...AddRewardData, [e.target.name]: value });
    };

    const onTextChange = (e) => {
        let value = e.target.value;
        setAddRewardData({ ...AddRewardData, [e.target.name]: value });
    };

    const onQuoteNumberChange = (e) => {
        let value = e.target.value === "" ? 0 : parseFloat(e.target.value);
        setAddQuoteReply({ ...AddQuoteReply, [e.target.name]: value });
    };

    const onDlvrNumberChange = (e) => {
        let value = e.target.value === "" ? 0 : parseFloat(e.target.value);
        setAddDlvrReply({ ...AddDlvrReply, [e.target.name]: value });
    };

    const onQuoteTextChange = (e) => {
        let value = e.target.value;
        setAddQuoteReply({ ...AddQuoteReply, [e.target.name]: value });
    };

    const onDlvrTextChange = (e) => {
        let value = e.target.value;
        setAddDlvrReply({ ...AddDlvrReply, [e.target.name]: value });
    };

    const UserSuccess = (data) => {
        let userlist = [];
        var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
        data.forEach(user => {
            if (user.Organization.length > 0 && userData._id !== user._id) {
                userlist.push({ value: user._id, label: user.FirstName + " " + user.LastName + " [" + user.Organization[0].Name + "]" });
            }
        });

        setTransferUsers(userlist);
    };

    const FetchAlertInfo = () => {
        var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
        Axiosfetch(baseURL + "GetLatestAlertByPartnerID", "POST", { Date: new Date(), EndDate: Date, PartnerID: userData.OrganizationID }, AlertSuccess, Failure);
    };

    const AlertSuccess = (data) => {
        if (data.length > 0) {
            setPartnerAdminAlert(data[0]);
        }
        else {
            setPartnerAdminAlert({});
        }
    }

    const FetchSurvey = () => {
        var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
        Axiosfetch(baseURL + "GetCustomersByOrgAndDate", "POST", {
            Date: moment().utc(),
            PartnerID: userData.OrganizationID
        }, SurveyDataSuccess, Failure);
    };

    const SurveyDataSuccess = (data) => {
        if (data.length > 0) {
            setPartnerSurvey(data);
        }
        else {
            setPartnerSurvey([]);
        }
    };

    const hideSurveyView = () => {
        setdisplayPartnerSurveyView("none");
    };

    const hideGoodsView = () => {
        setdisplayPartnerGoodsView("none");
    };

    const hideUserDirView = () => {
        setUserDirShow(false);
    }

    const hideUserAlertView = () => {
        setUserAlertShow(false);
    }

    const hideRewardAdd = () => {
        setdisplayAddRewardModel("none");
    };

    const OnTransferUserChange = (user) => {
        let userID = user ? user.value : "";
        setAddRewardData({ ...AddRewardData, "CreditTo": userID });
    };

    const AddRewardDetails = () => {
        if (Wallet.Points && AddRewardData.Points > 0 && Wallet.Points >= AddRewardData.Points && AddRewardData.CreditTo !== "" && AddRewardData.Remarks.trim() !== "") {
            let voucher = AddRewardData;
            voucher.IsTransfer = 1;
            voucher.Type = 3;
            voucher.JobID = 0;
            voucher.ExpiryDate = new Date();
            Axiosfetch(baseURL + "CreateMerchantRewards", "POST", voucher, TransferSuccess, Failure);
        }
        else {
            var error = ""
            if (Wallet.Points && Wallet.Points < AddRewardData.Points) {
                error = "Transfer Points cannot be greater than voucher Points";
            }
            else {
                error = "Invalid Data";
            }
            Alert.error(error, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const TransferSuccess = (data) => {
        if (data.success) {
            UpdateWalletPoints();
        }
        else {
            Alert.error("Error Transferring Wallet Points", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const UpdateWalletPoints = () => {
        if (Wallet && Wallet._id !== "") {
            let points = Wallet.Points - AddRewardData.Points;
            Axiosfetch(baseURL + "UpdateWallet", "POST", { _id: Wallet._id, Points: points }, UpdateTransferLog, Failure);
        }
    };

    const UpdateTransferLog = (data) => {
        if (data.success) {
            const userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;

            Axiosfetch(baseURL + "CreateTransferLog", "POST", {
                WalletID: Wallet._id,
                From: userData._id,
                To: AddRewardData.CreditTo,
                WalletPoints: Wallet.Points,
                TransferPoints: AddRewardData.Points,
                TransferBy: userData._id
            }, AddRewardsSuccess, Failure);
        }
        else {
            Alert.error("Error Transferring Wallet Points", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const AddRewardsSuccess = (data) => {
        if (data.success) {
            Alert.success(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });

            hideRewardAdd();
            setAddRewardData(rewards);
            OnWalletClick();
        }
        else {
            Alert.error(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const onSurveyView = (SurveyID) => {
        let surveyData = PartnerSurvey.filter(s => s._id === SurveyID);
        if (surveyData.length > 0) {
            setSelectedPartnerSurvey(surveyData[0]);
            setdisplayPartnerSurveyView("block");
        }
        else {
            setSelectedPartnerSurvey({});
            setdisplayPartnerSurveyView("none");
        }
    };

    const onGoodsView = (SurveyID) => {
        let surveyData = PartnerSurvey.filter(s => s._id === SurveyID);
        if (surveyData.length > 0 && surveyData[0].Goods.length > 0) {

            var cftValue = 0;
            surveyData[0].Goods.forEach(survey => {
                cftValue += (survey.CFTValue * survey.Quantity)
            });

            let vehcileData = VehicleChart.filter(v => v.MinCFT <= cftValue && v.MaxCFT >= cftValue);
            setPartnerVehicleRequired(vehcileData.length > 0 ? vehcileData[0].TypeOfLoad : "NA");

            setSelectedPartnerGoods(surveyData[0].Goods);
            setTotalPartnerCFT(cftValue);
            setdisplayPartnerGoodsView("block");
        }
        else {
            setSelectedPartnerGoods([]);
            setTotalPartnerCFT(0);
        }
    };

    const GetAlertTypeInfo = (alertType) => {
        switch (alertType) {
            case 1: return "green";
            case 2: return "#005582";
            case 3: return "red";
            default: return "green";
        }
    };

    const OnWalletClick = () => {
        var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
        Axiosfetch(baseURL + "GetRewardsByAgentID", "POST", { ID: userData._id }, RewardsSuccess, Failure);
    };

    const OnEnquiryClick = () => {
        setActivityOption(0);
        setIntServLeadFlag(0);
        setIntServQuoteFlag(0);
        setIntServDlvrFlag(0);
    };

    const RewardsSuccess = (data) => {
        setActivityOption(1);
        setIntServLeadFlag(0);
        setIntServQuoteFlag(0);
        setIntServDlvrFlag(0);
        if (data.length > 0) {
            setRewards(data);
        }
        else {
            setRewards([]);
        }
    };

    const OnWalletTrasfer = (rewards) => {
        setWallet(rewards);
        setAddRewardData({ ...AddRewardData, "Points": rewards.Points });
        setdisplayAddRewardModel("block");
    };

    const OnBorrowClick = () => {
        setActivityOption(2);
        setIntServLeadFlag(0);
        setIntServQuoteFlag(0);
        setIntServDlvrFlag(0);
        if (BorrowRequest.length === 0) {
            GetBorrowRequests();
        }
    };

    const OnLeadsClick = () => {
        setActivityOption(3);
        setIntServLeadFlag(0);
        setIntServQuoteFlag(0);
        setIntServDlvrFlag(0);
        if (Leads.length === 0) {
            GetLeads(LeadsType);
        }
    };

    const OnQuotesClick = () => {
        setActivityOption(4);
        setIntServLeadFlag(0);
        setIntServQuoteFlag(0);
        if (Quotes.length === 0) {
            GetQuotes(QuotesType);
        }
    };

    const OnDlvrClick = () => {
        setActivityOption(5);
        setIntServLeadFlag(0);
        setIntServQuoteFlag(0);
        if (Dlvrs.length === 0) {
            GetDlvrs(DlvrsType);
        }
    };

    const GetBorrowRequests = () => {
        var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
        Axiosfetch(baseURL + "GetBorrowRequestByRequestToID", "POST", { RequestTo: userData._id }, BorrowSuccess, Failure);
    };

    const GetLeads = (leadType) => {
        var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
        if (leadType === 1) {
            Axiosfetch(baseURL + "GetActiveIntServLeadsByPartnerID", "POST",
                { PartnerID: userData.Organization[0]._id }, LeadsSuccess, Failure);
        }
        else {
            Axiosfetch(baseURL + "GetIntServLeadsByOrgID", "POST",
                { OrgID: userData.Organization[0]._id }, LeadsSuccess, Failure);
        }
    };

    const GetQuotes = (quoteType) => {
        var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
        if (quoteType === 1) {
            Axiosfetch(baseURL + "GetActiveIntServQuotesByPartnerID", "POST",
                { PartnerID: userData.Organization[0]._id }, QuotesSuccess, Failure);
        }
        else {
            Axiosfetch(baseURL + "GetIntServQuotesByOrgID", "POST",
                { OrgID: userData.Organization[0]._id }, QuotesSuccess, Failure);
        }
    };

    const GetDlvrs = (dlvrType) => {
        var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
        if (dlvrType === 1) {
            Axiosfetch(baseURL + "GetActiveIntServDlvrByDestOrg", "POST",
                { DestOrg: userData.Organization[0]._id }, DlvrsSuccess, Failure);
        }
        else {
            Axiosfetch(baseURL + "GetActiveIntServDlvrByOrgID", "POST",
                { OrgID: userData.Organization[0]._id }, DlvrsSuccess, Failure);
        }
    };

    const LeadsSuccess = (data) => {
        if (data.length > 0) {
            setLeads(data);

            if (SelectedLeads._id !== undefined) {
                let leadDetails = data.filter(l => l._id === SelectedLeads._id);
                if (leadDetails.length > 0) {
                    setSelectedLeads(leadDetails[0]);
                }
            }
        }
        else {
            setLeads([]);
        }
    };

    const QuotesSuccess = (data) => {
        if (data.length > 0) {
            setQuotes(data);

            if (SelectedQuotes._id !== undefined) {
                let quoteDetails = data.filter(l => l._id === SelectedQuotes._id);
                if (quoteDetails.length > 0) {
                    setSelectedQuotes(quoteDetails[0]);
                }
            }
        }
        else {
            setQuotes([]);
        }
    };

    const DlvrsSuccess = (data) => {
        if (data.length > 0) {
            setDlvrs(data);

            if (SelectedDlvrs._id !== undefined) {
                let dlvrDetails = data.filter(l => l._id === SelectedDlvrs._id);
                if (dlvrDetails.length > 0) {
                    setSelectedDlvrs(dlvrDetails[0]);
                }
            }
        }
        else {
            setDlvrs([]);
        }
    };

    const BorrowSuccess = (data) => {
        if (data.length > 0) {
            setBorrowRequest(data);
        }
        else {
            setBorrowRequest([]);
        }
    };

    const NewBorrowRequestClick = () => {
        setdisplayBorrowRequest("block");
    };

    const hideBorrowRequestAdd = () => {
        setdisplayBorrowRequest("none");
    };

    const AddBorrowRequestDetails = () => {
        if (AddRewardData.Points > 0 && AddRewardData.CreditTo !== "" && AddRewardData.Remarks.trim() !== "") {
            var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
            let BorrowRequest = AddRewardData;
            BorrowRequest.RequestTo = AddRewardData.CreditTo;
            BorrowRequest.RequestBy = userData._id;
            BorrowRequest.ApprovedPoints = AddRewardData.Points;
            BorrowRequest.Approved = 0;
            Axiosfetch(baseURL + "CreateBorrowRequest", "POST", BorrowRequest, BorrowUpdateSuccess, Failure);
        }
        else {
            Alert.error("Invalid Data", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const BorrowUpdateSuccess = (data) => {
        if (data.success) {
            Alert.success(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });

            hideBorrowRequestAdd();
            setActivityOption(2);
            GetBorrowRequests();
        }
        else {
            Alert.error(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const OnBorrowApprove = (borrowID) => {
        Axiosfetch(baseURL + "ApproveBorrowRequest", "POST", { _id: borrowID }, BorrowUpdateSuccess, Failure);
    };

    const onRequestTypeChange = (request) => {
        let type = request ? request.value : 0;
        setAddRewardData({ ...AddRewardData, "RequestType": type });
    };

    const OnLeadSummary = (id) => {
        let leadDetails = Leads.filter(l => l._id === id);
        if (leadDetails.length > 0) {
            setSelectedLeads(leadDetails[0]);
            setIntServLeadFlag(1);
            setIntServQuoteFlag(0);
            setIntServDlvrFlag(0);
            setShowLogs(false);
            setQuoteReply(false);
            if (leadDetails[0].Organization && leadDetails[0].Organization.length > 0 && leadDetails[0].Organization[0].Logo !== "") {
                GetOrganizationLogo(leadDetails[0].Organization[0].Logo);
            }
        }
    };

    const OnQuoteSummary = (id) => {
        let quoteDetails = Quotes.filter(l => l._id === id);
        if (quoteDetails.length > 0) {
            setSelectedQuotes(quoteDetails[0]);
            setIntServQuoteFlag(1);
            setIntServDlvrFlag(0);
            setIntServLeadFlag(0);
            setShowLogs(false);
            setQuoteReply(false);
            if (quoteDetails[0].Organization && quoteDetails[0].Organization.length > 0 && quoteDetails[0].Organization[0].Logo !== "") {
                GetOrganizationLogo(quoteDetails[0].Organization[0].Logo);
            }
        }
    };

    const OnDlvrSummary = (id) => {
        let dlvrDetails = Dlvrs.filter(l => l._id === id);
        if (dlvrDetails.length > 0) {
            setSelectedDlvrs(dlvrDetails[0]);
            setIntServQuoteFlag(0);
            setIntServDlvrFlag(1);
            setIntServLeadFlag(0);
            setShowLogs(false);
            setDlvrReply(false);
            if (dlvrDetails[0].Organization && dlvrDetails[0].Organization.length > 0 && dlvrDetails[0].Organization[0].Logo !== "") {
                GetOrganizationLogo(dlvrDetails[0].Organization[0].Logo);
            }
        }
    };

    const GetOrganizationLogo = (logo) => {
        let file = logo;
        if (file !== null) {
            Axiosfetch(baseURL + "GetOrganizationLogo", "POST", { fileName: file }, LogoSuccess, Failure);
        }
    };

    const LogoSuccess = (data) => {
        if (data.success) {
            setLogoImage(data.fileData);
        }
        else {
            setLogoImage(null);
        }
    };

    const OnLeadDiscard = (LeadId) => {
        Axiosfetch(baseURL + "DiscardIntServLead", "POST", { _id: LeadId }, LeadDiscardedSuccess, Failure);
    };

    const OnQuoteDiscard = (quoteId) => {
        let logs = SelectedQuotes.QuoteLogs !== null ? SelectedQuotes.QuoteLogs : [];
        logs.push({ CreatedDate: moment(), Remarks: (QuotesType === 1 ? "Quote Rejected" : "Quote Deleted"), Amount: 0 });

        Axiosfetch(baseURL + "DiscardIntServQuote", "POST", { _id: quoteId, QuoteLogs: logs }, LeadDiscardedSuccess, Failure);
    };

    const OnDlvrDiscard = (dlvrId) => {
        let logs = SelectedDlvrs.DeliveryLogs !== null ? SelectedDlvrs.DeliveryLogs : [];
        logs.push({ CreatedDate: moment(), Remarks: (QuotesType === 1 ? "Delivery Rejected" : "Delivery Deleted"), Amount: 0 });

        Axiosfetch(baseURL + "DiscardIntServDlvr", "POST", { _id: dlvrId, DeliveryLogs: logs }, LeadDiscardedSuccess, Failure);
    };

    const OnDlvrComplete = (dlvrId) => {
        Axiosfetch(baseURL + "CompleteIntServDlvr", "POST", { _id: dlvrId, CompletedOn: moment() }, LeadDiscardedSuccess, Failure);
    };

    const OnDlvrApprove = (dlvrId) => {
        Axiosfetch(baseURL + "ApproveIntServDlvr", "POST", { _id: dlvrId, CompletedOn: moment() }, LeadDiscardedSuccess, Failure);
    };

    const LeadDiscardedSuccess = (data) => {
        if (data.success) {
            Alert.success(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });

            if (ActivityOption === 3) {
                GetLeads(LeadsType);
            }
            if (ActivityOption === 5) {
                GetDlvrs(DlvrsType);
            }
            else {
                GetQuotes(QuotesType);
            }

            setIntServLeadFlag(0);
            setIntServQuoteFlag(0);
            setIntServDlvrFlag(0);
        }
        else {
            Alert.error(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const UpdateLogs = (LeadId, status) => {
        if (LeadId !== "") {
            // check if lead step is already executed
            if (SelectedLeads && SelectedLeads.LeadLogs && SelectedLeads.LeadLogs.length >= status) {
                Alert.error("Lead Step already executed.", {
                    position: 'bottom-right',
                    effect: 'slide',
                    html: false
                });
            }
            // check if any lead step is missed before proceeding
            else if ((SelectedLeads && SelectedLeads.LeadLogs === null && status === 1) ||
                (SelectedLeads && SelectedLeads.LeadLogs && SelectedLeads.LeadLogs.length === status - 1)) {

                // if status 4(completed) is selelcted then change statud of Lead to 2 (Finished)
                // else
                // keep the status 1 (Active)
                var leadStatus = (status === 4) ? 2 : 1;
                let logs = SelectedLeads.LeadLogs !== null ? SelectedLeads.LeadLogs : [];
                logs.push({ CreatedDate: moment(), Remarks: null, Status: status })
                Axiosfetch(baseURL + "UpdateIntServLeadLogs", "POST",
                    { _id: LeadId, LeadLogs: logs, Status: leadStatus }, LeadLogsUpdateSuccess, Failure);

                if (status === 4) {
                    setSelectedLeads({});
                    setIntServLeadFlag(0);
                    setIntServQuoteFlag(0);
                    setIntServDlvrFlag(0);
                }
            }
            else {
                Alert.error("Please complete step " + (status - 1) + " to proceed.", {
                    position: 'bottom-right',
                    effect: 'slide',
                    html: false
                });
            }
        }
    };

    const LeadLogsUpdateSuccess = (data) => {
        if (data.success) {
            Alert.success(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });

            GetLeads(LeadsType);
        }
        else {
            Alert.error(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const QuoteLogsUpdateSuccess = (data) => {
        if (data.success) {
            Alert.success(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });

            setQuoteReply(false);
            setAddQuoteReply(quotereply);
            GetQuotes(QuotesType);
        }
        else {
            Alert.error(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const DlvrLogsUpdateSuccess = (data) => {
        if (data.success) {
            Alert.success(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });

            setDlvrReply(false);
            setAddDlvrReply(quotereply);
            GetDlvrs(DlvrsType);
        }
        else {
            Alert.error(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const GetLogsStatusName = (status) => {
        switch (status) {
            case 1: return "Accept";
            case 2: return "In Progress";
            case 3: return "Booked";
            case 4: return "Completed";
            default: return "";
        };
    };

    const onShowLogs = () => {
        setShowLogs(!ShowLogs);
        setQuoteReply(false);
        setDlvrAdditionalInfo(false);
        setDlvrTerms(false);
    }

    const onShowQuoteReply = () => {
        setQuoteReply(!QuoteReply);
        setShowLogs(false);
    }

    const onShowDlvrTerms = () => {
        setDlvrTerms(!DlvrTerms);
        setShowLogs(false);
        setDlvrAdditionalInfo(false);
        setQuoteReply(false);
    }

    const onShowDlvrReply = () => {
        setDlvrReply(!DlvrReply);
        setShowLogs(false);
        setDlvrAdditionalInfo(false);
        setDlvrTerms(false);
    }

    const Failure = (err) => {
        FailureAlert(err);
    };

    const onQuoteReplySave = (QuoteId) => {
        if (QuoteId !== "" && AddQuoteReply.Amount && AddQuoteReply.Amount > 0) {
            let logs = SelectedQuotes.QuoteLogs !== null ? SelectedQuotes.QuoteLogs : [];
            logs.push({ CreatedDate: moment(), Remarks: AddQuoteReply.Remarks, Amount: AddQuoteReply.Amount })
            Axiosfetch(baseURL + "UpdateIntServQuoteLogs", "POST",
                { _id: QuoteId, QuoteLogs: logs }, QuoteLogsUpdateSuccess, Failure);
        }
        else {
            Alert.error("Enter valid Quote Reply", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const onDlvrReplySave = (DlvrId) => {
        if (DlvrId !== "" && AddDlvrReply.Amount && AddDlvrReply.Amount > 0) {
            let logs = SelectedDlvrs.DeliveryLogs !== null ? SelectedDlvrs.DeliveryLogs : [];
            logs.push({ CreatedDate: moment(), Remarks: AddDlvrReply.Remarks, Amount: AddDlvrReply.Amount })
            Axiosfetch(baseURL + "UpdateIntServDlvrLogs", "POST",
                { _id: DlvrId, DeliveryLogs: logs }, DlvrLogsUpdateSuccess, Failure);
        }
        else {
            Alert.error("Enter valid Delivery Reply", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const OnDlvrClose = (dlvrId) => {
        Axiosfetch(baseURL + "CloseIntServDlvr", "POST", { _id: dlvrId }, LeadDiscardedSuccess, Failure);
    }

    const onShowAdditionalInfo = () => {
        setDlvrAdditionalInfo(!DlvrAdditionalInfo);
        setDlvrTerms(false);
        setDlvrReply(false);
    }

    const OnLeadsType = (leadtype) => {
        setLeadsType(leadtype);
        GetLeads(leadtype);

        setIntServLeadFlag(0);
        setIntServQuoteFlag(0);
        setIntServDlvrFlag(0);
    };

    const OnQuotesType = (quotetype) => {
        setQuotesType(quotetype);
        GetQuotes(quotetype);

        setIntServLeadFlag(0);
        setIntServQuoteFlag(0);
        setIntServDlvrFlag(0);
    }

    const OnDlvrsType = (dlvrtype) => {
        setDlvrType(dlvrtype);
        GetDlvrs(dlvrtype);

        setIntServLeadFlag(0);
        setIntServQuoteFlag(0);
        setIntServDlvrFlag(0);
    }

    const onUserDir = () => {
        setUserDirShow(!UserDirShow);
    }

    const onUserAlerts = () => {
        setUserAlertShow(!UserAlertShow);
    }

    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme cd-background sidemenu-show" style={{
                marginBottom: "0.8rem",
                backgroundRepeat: "round", backgroundSize: "contain", backgroundImage: `url('${PickNTrackPattern}')`
            }}>
                <div className="row" style={{ marginLeft: "0.2rem" }}
                >
                    <div className="col-md-4 border-right-style" style={{ backgroundColor: "rgba(255,255,255,0.8)" }}>
                        <div style={{ textAlign: "center", fontSize: "1.2rem", padding: "5px" }}>
                            <div className='pb-1' style={{ display: "flex", justifyContent: "space-evenly" }}>
                                <span className="cursor onhover" style={{ paddingRight: "15px", color: (ActivityOption === 0 ? "green" : "black") }} data-tip="Enquiry" onClick={OnEnquiryClick}><FontAwesomeIcon icon={faPrint} /></span>
                                <span className="cursor onhover" style={{ paddingRight: "15px", color: (ActivityOption === 1 ? "green" : "black") }} data-tip="e-Batua" onClick={OnWalletClick}><FontAwesomeIcon icon={faWallet} /></span>
                                <span className="cursor onhover" style={{ paddingRight: "15px", color: (ActivityOption === 2 ? "green" : "black") }} data-tip="Purchase Request" onClick={OnBorrowClick}><FontAwesomeIcon icon={faHandHoldingUsd} /></span>
                                <span className="cursor onhover" style={{ paddingRight: "15px", color: (ActivityOption === 3 ? "green" : "black") }} data-tip="Leads Enquiry" onClick={OnLeadsClick}><FontAwesomeIcon icon={faUsers} /></span>
                                <span className="cursor onhover" style={{ paddingRight: "15px", color: (ActivityOption === 4 ? "green" : "black") }} data-tip="Quotes Enquiry" onClick={OnQuotesClick}><FontAwesomeIcon icon={faFileSignature} /></span>
                                <span className="cursor onhover" style={{ paddingRight: "15px", color: (ActivityOption === 5 ? "green" : "black") }} data-tip="Delivery Enquiry" onClick={OnDlvrClick}><FontAwesomeIcon icon={faTruck} /></span>
                                <span className="cursor onhover" style={{ paddingRight: "15px" }} data-tip="#mfimovers - Directory" onClick={onUserDir}><FontAwesomeIcon icon={faUserCheck} /></span>
                                <span className="cursor onhover" data-tip="see Alerts" onClick={onUserAlerts}><FontAwesomeIcon icon={faBell} /></span>
                            </div>
                        </div>
                        {ActivityOption === 0 && (<div style={{ backgroundColor: "rgba(255,255,255,0.8)", borderRadius: "6px", border: "1px solid #ddd", height: "70vh", padding: "0 10px", overflow: "auto", overflowX: "hidden" }}>
                            <div style={{ textAlign: "center", fontSize: "1.2rem" }}>{ActivityOption === 0 ? "Enquiry" : (ActivityOption === 1 ? "e-Batua" : (ActivityOption === 2) ? "Purchase" : (ActivityOption === 3 ? "Leads" : (ActivityOption === 4 ? "Quotes" : "Delivery")))}</div>
                            {PartnerEnquiry.length > 0 && PartnerEnquiry.map(enquiry => (
                                <div title={(enquiry.SurveyRequired === 1 ? "Survey Required" : "Survey Not Required")} className="EnquiryList" key={enquiry._id} style={{
                                    backgroundColor: "white", borderLeft: (enquiry.SurveyRequired === 1 ? "5px solid green" : "5px solid red")
                                }}>
                                    <div className='mb-2' style={{ fontSize: "1rem" }}>{enquiry.Subject} - {enquiry.MoveType}</div>
                                    {enquiry.User.length > 0 && (<div style={{ border: "1px solid #ccc", padding: "2px", borderRadius: "6px" }}>
                                        <span style={{ paddingRight: "10px" }}><FontAwesomeIcon icon={faPhoneVolume} /></span>
                                        {enquiry.User.length > 0 && enquiry.User[0].FirstName + " " + enquiry.User[0].LastName + " - "}
                                        <a style={{ textDecoration: "none" }} href={`tel:+91${enquiry.User[0].PhoneNumber}`}>{enquiry.User[0].PhoneNumber}</a>
                                    </div>)}
                                    <div style={{ padding: "2px 0" }}><span><FontAwesomeIcon icon={faMapMarkerAlt} /></span><span> {enquiry.City}, {enquiry.State}, {enquiry.Country}</span></div>
                                    <div style={{ color: "gray", fontSize: "13px" }}>Created On : {moment(enquiry.createdAt).local().format("DD/MM/YYYY hh:mm:ss A")}</div>
                                </div>
                            ))}
                            {PartnerEnquiry.length === 0 && (<div className="NoItemStyle">No Pending Enquiry</div>)}
                        </div>)}
                        {ActivityOption === 1 && (<div style={{ backgroundColor: "rgba(255,255,255,0.8)", borderRadius: "6px", border: "1px solid #ddd", height: "75vh", padding: "0 10px", overflow: "auto", overflowX: "hidden" }}>
                            <div style={{ textAlign: "center", fontSize: "1.2rem" }}>{ActivityOption === 0 ? "Enquiry" : (ActivityOption === 1 ? "e-Batua" : (ActivityOption === 2) ? "Purchase" : (ActivityOption === 3 ? "Leads" : (ActivityOption === 4 ? "Quotes" : "Delivery")))}</div>
                            {Rewards.length > 0 && Rewards.map(reward => (
                                <div className="EnquiryList" key={reward._id} style={{ backgroundColor: "white" }}>
                                    <div style={{ padding: "3px", borderRadius: "6px" }}>
                                        <span style={{ textTransform: "uppercase" }}>{reward._id}</span>
                                        <span className="cursor" title="Transfer" style={{ float: "right", paddingRight: "5px" }} onClick={() => OnWalletTrasfer(reward)}>
                                            <FontAwesomeIcon style={{ color: "#005582" }} icon={faRandom} /></span>
                                    </div>
                                    <span style={{ fontSize: "2rem" }}>{reward.Points}</span>
                                    <div style={{ color: "gray", fontSize: "13px" }}>Created On : {moment(reward.createdAt).local().format("DD/MM/YYYY hh:mm:ss A")}</div>
                                </div>
                            ))}
                            {Rewards.length === 0 && (<div className="NoItemStyle">No Wallet Points</div>)}
                        </div>)}
                        {ActivityOption === 2 && (<div style={{ backgroundColor: "rgba(255,255,255,0.8)", borderRadius: "6px", border: "1px solid #ddd", height: "70vh", padding: "0 10px", overflow: "auto", overflowX: "hidden" }}>
                            <div style={{ textAlign: "center", fontSize: "1.2rem" }}>{ActivityOption === 0 ? "Enquiry" : (ActivityOption === 1 ? "e-Batua" : (ActivityOption === 2) ? "Purchase" : (ActivityOption === 3 ? "Leads" : (ActivityOption === 4 ? "Quotes" : "Delivery")))}</div>
                            <div className='mt-1' style={{ border: "1px solid #ccc", cursor: "pointer", borderRadius: "6px", padding: "5px", width: "100%", textAlign: "center" }}>
                                <span style={{ paddingRight: "10px" }}><FontAwesomeIcon icon={faPlus} /></span>
                                <span className="onhover" title="Click on add Borrow Request" onClick={NewBorrowRequestClick}>Add New Purchase Request</span>
                                <span className="onhover" title="Refresh" onClick={GetBorrowRequests} style={{ paddingRight: "10px", float: "right" }}><FontAwesomeIcon icon={faSyncAlt} /></span>
                            </div>
                            {BorrowRequest.length > 0 && BorrowRequest.map(borrow => (
                                <div className="EnquiryList" key={borrow._id} style={{ backgroundColor: "white" }}>
                                    <div style={{ padding: "3px", borderRadius: "6px" }}>
                                        <span>{(borrow.RequestTo ? `By : ${borrow.RequestTo[0].FirstName} ${borrow.RequestTo[0].LastName}` : "")}</span>
                                        <span className="cursor" title="Approve" style={{ float: "right", paddingRight: "5px" }} onClick={() => OnBorrowApprove(borrow._id)}>
                                            <FontAwesomeIcon style={{ color: "green" }} icon={faThumbsUp} /></span>
                                    </div>
                                    <div style={{ fontSize: "2rem", display: "flex", justifyContent: "center" }}>
                                        <div style={{ paddingRight: "20px", margin: "auto 0", fontSize: "1.2rem" }} title={(borrow.RequestType === 1 ? "Purchase" : "Request")}>
                                            <FontAwesomeIcon style={{ color: (borrow.RequestType !== 1 ? "orange" : "black") }} icon={borrow.RequestType === 1 ? faHandHoldingMedical : faCoins} />
                                        </div>
                                        <div>{borrow.Points}</div>
                                    </div>
                                    <div title={borrow.Remarks} style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}><b>Remarks</b> : {borrow.Remarks}</div>
                                    <div style={{ color: "gray", fontSize: "13px" }}>Created On : {moment(borrow.createdAt).local().format("DD/MM/YYYY hh:mm:ss A")}</div>
                                </div>
                            ))}
                            {BorrowRequest.length === 0 && (<div className="NoItemStyle">No Pending Borrow Request</div>)}
                        </div>)}
                        {ActivityOption === 3 && (<div style={{ backgroundColor: "rgba(255,255,255,0.8)", borderRadius: "6px", border: "1px solid #ddd", height: "75vh", padding: "0 10px", overflow: "auto", overflowX: "hidden" }}>
                            <div style={{ textAlign: "center", fontSize: "1.2rem" }}>{ActivityOption === 0 ? "Enquiry" : (ActivityOption === 1 ? "e-Batua" : (ActivityOption === 2) ? "Purchase" : (ActivityOption === 3 ? "Leads" : (ActivityOption === 4 ? "Quotes" : "Delivery")))}</div>
                            <div className="mt-1 row align-center" style={{ border: "1px solid #ccc" }}>
                                <div onClick={() => OnLeadsType(0)} className={`col-md-6 col-6  cursor ${LeadsType === 0 ? CurrentTheme.concat(" color-white") : ""}`} style={{ borderRight: "1px solid #ccc" }}>My Leads</div>
                                <div onClick={() => OnLeadsType(1)} className={`col-md-6 col-6  cursor ${LeadsType === 1 ? CurrentTheme.concat(" color-white") : ""}`}>Member Leads</div>
                            </div>
                            {Leads.length > 0 && Leads.map(lead => (
                                <div className="EnquiryList cursor" key={lead._id}
                                    style={{ backgroundColor: "white", position: "relative", border: ((SelectedLeads && SelectedLeads._id && SelectedLeads._id === lead._id) ? "2px solid #00b300" : "1px solid #ccc") }}>
                                    <FontAwesomeIcon className={`${CurrentTheme}Color`} style={{
                                        paddingRight: "10px", left: "10px",
                                        position: "absolute", fontSize: "2rem"
                                    }} icon={faFileAlt}></FontAwesomeIcon>
                                    <div onClick={() => OnLeadSummary(lead._id)}>
                                        {lead.Organization && lead.Organization.length > 0 &&
                                            (<span style={{ fontSize: "1rem" }}>{lead.Organization[0].Name}</span>)}
                                        <div title={lead.Remarks} style={{ overflow: "hidden", padding: "5px", textOverflow: "ellipsis", whiteSpace: "nowrap" }}><b>Remarks</b> : {lead.Remarks}</div>
                                        <div style={{ color: "gray", fontSize: "13px" }}>Created On : {moment(lead.createdAt).local().format("DD/MM/YYYY hh:mm:ss A")}</div>
                                    </div>
                                </div>
                            ))}
                            {Leads.length === 0 && (<div className="NoItemStyle">{(LeadsType === 1 ? "No Pending Leads Request" : "No Leads Available")}</div>)}
                        </div>)}
                        {ActivityOption === 4 && (<div style={{ backgroundColor: "rgba(255,255,255,0.8)", borderRadius: "6px", border: "1px solid #ddd", height: "75vh", padding: "0 10px", overflow: "auto", overflowX: "hidden" }}>
                            <div style={{ textAlign: "center", fontSize: "1.2rem" }}>{ActivityOption === 0 ? "Enquiry" : (ActivityOption === 1 ? "e-Batua" : (ActivityOption === 2) ? "Purchase" : (ActivityOption === 3 ? "Leads" : (ActivityOption === 4 ? "Quotes" : "Delivery")))}</div>
                            <div className="mt-1 row align-center" style={{ border: "1px solid #ccc" }}>
                                <div onClick={() => OnQuotesType(0)} className={`col-md-6 col-6 cursor ${QuotesType === 0 ? CurrentTheme.concat(" color-white") : ""}`} style={{ borderRight: "1px solid #ccc" }}>My Quotes</div>
                                <div onClick={() => OnQuotesType(1)} className={`col-md-6 col-6 cursor ${QuotesType === 1 ? CurrentTheme.concat(" color-white") : ""}`}>Member Quotes</div>
                            </div>
                            {Quotes.length > 0 && Quotes.map(quote => (
                                <div className="EnquiryList cursor" key={quote._id}
                                    style={{ position: "relative", backgroundColor: "white", border: ((SelectedQuotes && SelectedQuotes._id && SelectedQuotes._id === quote._id) ? "2px solid #00b300" : "1px solid #ccc") }}>
                                    <FontAwesomeIcon className={`${CurrentTheme}Color`} style={{ paddingRight: "10px", left: "10px", position: "absolute", fontSize: "2rem" }} icon={faFileInvoice}></FontAwesomeIcon>
                                    <div onClick={() => OnQuoteSummary(quote._id)}>

                                        {quote.Organization && quote.Organization.length > 0 &&
                                            (<span style={{ fontSize: "1rem" }}>{quote.Organization[0].Name}</span>)}
                                        <div style={{ fontSize: "1.2rem", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{`Total CFT : ${quote.CFT}`}</div>
                                        <div style={{ overflow: "hidden", margin: "5px 0", fontWeight: "bold", backgroundColor: "#eee", borderRadius: "10px", color: "#005582", textTransform: "uppercase", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>

                                            {`${quote.Source} - ${quote.Dest}`}
                                        </div>
                                        <div style={{ color: "gray", fontSize: "13px" }}>Created On : {moment(quote.createdAt).local().format("DD/MM/YYYY hh:mm:ss A")}</div>

                                    </div>
                                </div>
                            ))}
                            {Quotes.length === 0 && (<div className="NoItemStyle">{(QuotesType === 1 ? "No Pending Quotes Request" : "No Quotes Available")}</div>)}
                        </div>)}
                        {ActivityOption === 5 && (<div style={{ backgroundColor: "rgba(255,255,255,0.8)", borderRadius: "6px", border: "1px solid #ddd", height: "75vh", padding: "0 10px", overflow: "auto", overflowX: "hidden" }}>
                            <div style={{ textAlign: "center", fontSize: "1.2rem" }}>{ActivityOption === 0 ? "Enquiry" : (ActivityOption === 1 ? "e-Batua" : (ActivityOption === 2) ? "Purchase" : (ActivityOption === 3 ? "Leads" : (ActivityOption === 4 ? "Quotes" : "Delivery")))}</div>
                            <div className="mt-1 row align-center" style={{ border: "1px solid #ccc" }}>
                                <div onClick={() => OnDlvrsType(0)} className={`col-md-6 col-6 cursor ${DlvrsType === 0 ? CurrentTheme.concat(" color-white") : ""}`} style={{ borderRight: "1px solid #ccc" }}>My Deliveries</div>
                                <div onClick={() => OnDlvrsType(1)} className={`col-md-6 col-6 cursor ${DlvrsType === 1 ? CurrentTheme.concat(" color-white") : ""}`}>Member Deliveries</div>
                            </div>
                            {Dlvrs.length > 0 && Dlvrs.map(dlvr => (
                                <div className="EnquiryList cursor" key={dlvr._id}
                                    style={{ position: "relative", backgroundColor: "white", border: ((SelectedDlvrs && SelectedDlvrs._id && SelectedDlvrs._id === dlvr._id) ? "2px solid #00b300" : "1px solid #ccc") }}>

                                    <div onClick={() => OnDlvrSummary(dlvr._id)}>

                                        {dlvr.Organization && dlvr.Organization.length > 0 &&
                                            (<span>
                                                <span><FontAwesomeIcon className={`${CurrentTheme}Color`} style={{ paddingRight: "10px", left: "10px", position: "absolute", fontSize: "1.5rem" }} icon={faTruckLoading}></FontAwesomeIcon></span>
                                                <span style={{ fontSize: "1rem" }} className='pl-4'>
                                                    {dlvr.Organization[0].Name}
                                                </span>
                                            </span>)}
                                        <div className='mt-1' style={{ fontSize: "1rem", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{`Total CFT : ${dlvr.TotalCFT}`}</div>
                                        <div style={{ overflow: "hidden", margin: "5px 0", fontWeight: "bold", backgroundColor: "#eee", borderRadius: "10px", color: "#005582", textTransform: "uppercase", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>

                                            {`${dlvr.OriginCity} - ${dlvr.DestCity}`}
                                        </div>
                                        {DlvrsType === 0 && dlvr.DestOrganization && dlvr.DestOrganization.length > 0 && (<span>To : {dlvr.DestOrganization[0].Name}</span>)}
                                        <div style={{ color: "gray", fontSize: "13px" }}>Created On : {moment(dlvr.createdAt).local().format("DD/MM/YYYY hh:mm:ss A")}</div>

                                    </div>
                                </div>
                            ))}
                            {Dlvrs.length === 0 && (<div className="NoItemStyle">{(DlvrsType === 1 ? "No Pending Deliveries Request" : "No Deliveries Available")}</div>)}
                        </div>)}
                    </div>
                    <div className="col-md-8" style={{ height: "80vh", overflow: "auto" }}>
                        {PartnerAdminAlert.AlertDesc !== undefined && (<div className="row" style={{ paddingBottom: "20px" }}>
                            <div className="col-md-12">
                                <div className="admin-alert marquee">
                                    <span style={{ color: GetAlertTypeInfo(PartnerAdminAlert.Type) }}>{PartnerAdminAlert.AlertDesc}</span>
                                </div>
                            </div>
                        </div>)}
                        {IntServLeadFlag !== 1 && IntServQuoteFlag !== 1 && IntServDlvrFlag !== 1 && (<div className="row">
                            <div className="col-md-12">
                                <div style={{ height: "50vh", padding: "0 10px", overflow: "auto", overflowX: "hidden" }}>
                                    <table className="table table-striped align-center">
                                        <thead>
                                            <tr>
                                                <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Survey No.</th>
                                                <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Delivery Date</th>
                                                <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>View</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {PartnerSurvey.length > 0 && PartnerSurvey.map(survey => (
                                                <tr key={survey._id}>
                                                    <td>{survey.SurveyID + "-" + moment(survey.createdAt).local().format("DDMMYYYY")}</td>
                                                    <td>{moment(survey.PreferredDeliveryDate).local().format("DD/MM/YYYY")}</td>
                                                    <td><div style={{ display: "flex", justifyContent: "space-evenly" }}>
                                                        <span onClick={() => onSurveyView(survey._id)} className="cursor" title="View Survey"><FontAwesomeIcon icon={faEye} /></span>
                                                        <span onClick={() => onGoodsView(survey._id)} className="cursor" title="View Goods"><FontAwesomeIcon icon={faBoxOpen} /></span>
                                                    </div></td>
                                                </tr>
                                            ))}
                                            {PartnerSurvey.length === 0 && (<tr><td colSpan="3"><div>No Pending Survey</div></td></tr>)}
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                        </div>)}
                        {IntServLeadFlag === 1 && (<div className="row">
                            <div className="col-md-12">
                                {SelectedLeads._id !== undefined && (
                                    <div className="card">
                                        <div className="card-body p-0">
                                            <div style={{ display: "flex", justifyContent: "space-between" }} className="card-title p-2 border-bottom">
                                                <h4 style={{ paddingLeft: "1rem" }}>Summary</h4>
                                                <span className="cursor" title="Discard" style={{
                                                    fontSize: "22px", color: "red",
                                                    paddingRight: "10px"
                                                }} onClick={() => OnLeadDiscard(SelectedLeads._id)}>
                                                    <FontAwesomeIcon icon={faTimes} /></span>
                                            </div>
                                            <div className="card-text p-1">
                                                <div className="row" style={{ margin: "0 10px" }}>
                                                    <div className="col-md-7 col-12" style={{ display: "flex", paddingLeft: "1rem", alignItems: "center" }}>
                                                        <div>
                                                            {LogoImage && (
                                                                <img className="companylogoStyle" alt="Org Logo" width="120" height="120" src={LogoImage}></img>)}
                                                        </div>
                                                        {SelectedLeads.Organization && SelectedLeads.Organization.length > 0 &&
                                                            (<div className="p-2" style={{ flex: "2" }}>
                                                                <h5>MFI {SelectedLeads.Organization[0].City}</h5>
                                                                <i><h6>{SelectedLeads.Organization[0].Name}</h6></i>
                                                                <i><h6>Ph No. : {SelectedLeads.Organization[0].Contact}</h6></i>
                                                            </div>)}
                                                    </div>
                                                    <div className="col-md-5 col-12 p-2 border" style={{ textAlign: "center", paddingLeft: "5px", borderRadius: "10px" }}>
                                                        <h5 className="p-1" style={{ borderBottom: "1px solid #ccc" }}>Customer Details</h5>
                                                        <div>{SelectedLeads.CustName}</div>
                                                        <i><div>Ph No. : {SelectedLeads.CustContact}</div></i>
                                                        {SelectedLeads.CustEmail !== "" && (<i><div>Email : {SelectedLeads.CustEmail}</div></i>)}

                                                    </div>
                                                </div>
                                                <div className="p-3 align-center">
                                                    <h6><i>"{SelectedLeads.Remarks}"</i></h6>
                                                </div>
                                                <div className="sourceDest-style">
                                                    <h5>{SelectedLeads.CustSource}</h5>
                                                    <h5>{SelectedLeads.CustDest}</h5>
                                                </div>
                                            </div>

                                            <div style={{ paddingTop: "5px" }}>
                                                <ul className="progressbar">
                                                    <li onClick={() => UpdateLogs((SelectedLeads._id || ""), 1)}
                                                        className={SelectedLeads && SelectedLeads.LeadLogs && SelectedLeads.LeadLogs.length > 0 ? "active" : ""}>
                                                        Accept
                                                    </li>
                                                    <li onClick={() => UpdateLogs((SelectedLeads._id || ""), 2)}
                                                        className={SelectedLeads && SelectedLeads.LeadLogs && SelectedLeads.LeadLogs.length > 1 ? "active" : ""}>
                                                        In Progress
                                                    </li>
                                                    <li onClick={() => UpdateLogs((SelectedLeads._id || ""), 3)}
                                                        className={SelectedLeads && SelectedLeads.LeadLogs && SelectedLeads.LeadLogs.length > 2 ? "active" : ""}>
                                                        Booked
                                                    </li>
                                                    <li onClick={() => UpdateLogs((SelectedLeads._id || ""), 4)}
                                                        className={SelectedLeads && SelectedLeads.LeadLogs && SelectedLeads.LeadLogs.length > 3 ? "active" : ""}>
                                                        Complete
                                                    </li>
                                                </ul>
                                            </div>

                                            {(SelectedLeads && SelectedLeads.LeadLogs &&
                                                SelectedLeads.LeadLogs.length > 0) && (<div style={{ marginBottom: "40px" }}>
                                                    <div onClick={onShowLogs} className="Logs-show-style">Logs
                                                        <span className="cursor hover-style" title="Hide / Show Logs" style={{ paddingRight: "20px", float: "right" }}><FontAwesomeIcon icon={!ShowLogs ? faPlus : faMinus} /></span></div>
                                                    {ShowLogs && (<div className="m-3"><table className="table table-striped table-bordered">
                                                        <tbody>
                                                            {SelectedLeads.LeadLogs.map((logs, index) => (
                                                                <tr className="border-bottom" key={logs + "_" + index}>
                                                                    <td>
                                                                        <div style={{ padding: "0 20px" }} className="align-center">{index + 1}</div>
                                                                    </td>
                                                                    <td>
                                                                        <div className="align-left">{GetLogsStatusName(logs.Status)}</div></td>
                                                                    <td>
                                                                        <div className="align-center">{moment(logs.CreatedDate).local().format("DD/MM/YYYY hh:mm:ss A")}</div>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                    </div>)}
                                                </div>)}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>)}
                        {IntServQuoteFlag === 1 && (<div className="row">
                            <div className="col-md-12 col-12">
                                {SelectedQuotes._id !== undefined && (
                                    <div className="card">
                                        <div className="card-body p-0">
                                            <div style={{ display: "flex", justifyContent: "space-between" }} className="card-title p-2 border-bottom">
                                                <h4 style={{ paddingLeft: "1rem" }}>Summary</h4>
                                                <span className="cursor" title="Discard" style={{
                                                    fontSize: "22px", color: "red",
                                                    paddingRight: "10px"
                                                }} onClick={() => OnQuoteDiscard(SelectedQuotes._id)}>
                                                    <FontAwesomeIcon icon={faTimes} /></span>
                                            </div>
                                            <div className="card-text p-1">
                                                <div className="row" style={{ margin: "0 10px" }}>
                                                    <div className="col-md-9 col-12" style={{ display: "flex", paddingLeft: "1rem", alignItems: "center" }}>
                                                        <div>
                                                            {LogoImage && (
                                                                <img className="companylogoStyle" alt="Org Logo" width="120" height="120" src={LogoImage}></img>)}
                                                        </div>
                                                        {SelectedQuotes.Organization && SelectedQuotes.Organization.length > 0 &&
                                                            (<div className="p-2" style={{ flex: "2" }}>
                                                                <h5>MFI {SelectedQuotes.Organization[0].City}</h5>
                                                                <i><h6>{SelectedQuotes.Organization[0].Name}</h6></i>
                                                                <i><h6>Ph No. : {SelectedQuotes.Organization[0].Contact}</h6></i>
                                                            </div>)}
                                                    </div>
                                                    <div className="col-md-3 col-12 p-2" style={{ textAlign: "center", paddingLeft: "5px" }}>
                                                        <h5 className={`p-1 ${CurrentTheme}`} style={{ color: "white", borderRadius: "10px" }}>CFT - {SelectedQuotes.CFT}</h5>
                                                    </div>
                                                </div>
                                                <div className="p-3 align-center">
                                                    <h6 title={SelectedQuotes.Remarks} style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}><i>"{SelectedQuotes.Remarks}"</i></h6>
                                                </div>
                                                <div className="sourceDest-style">
                                                    <h5>{SelectedQuotes.Source}</h5>
                                                    <h5>{SelectedQuotes.Dest}</h5>
                                                </div>
                                                <div>
                                                    {QuotesType === 1 && (<div onClick={onShowQuoteReply} className="Logs-show-style">Quote Reply
                                                        <span className="cursor hover-style" title="Hide / Show Logs"
                                                            style={{ paddingRight: "20px", float: "right" }}>
                                                            <FontAwesomeIcon icon={!QuoteReply ? faPlus : faMinus} />
                                                        </span>
                                                    </div>)}
                                                    {QuoteReply && (<div style={{ marginBottom: "5px" }}><div className="text-field">
                                                        <input placeholder="" name="Amount" value={AddQuoteReply.Amount ? AddQuoteReply.Amount : 0}
                                                            onChange={(e) => onQuoteNumberChange(e)}
                                                            type="number"></input>
                                                        <span >Amount<span className="mandatoryStar">*</span></span>
                                                    </div>
                                                        <div className="text-field">
                                                            <textarea placeholder="" name="Remarks" rows="3"
                                                                value={AddQuoteReply.Remarks ? AddQuoteReply.Remarks : ""}
                                                                onChange={(e) => onQuoteTextChange(e)}></textarea>
                                                            <span>Remarks</span>
                                                        </div>
                                                        <div className="buttonresponsive align-right">
                                                            <button onClick={() => onQuoteReplySave(SelectedQuotes._id)} className={`btn btn-Save ${CurrentTheme}Focus`}>Reply</button>
                                                        </div>
                                                    </div>)}
                                                </div>
                                            </div>
                                            {(SelectedQuotes && SelectedQuotes.QuoteLogs &&
                                                SelectedQuotes.QuoteLogs.length > 0) && (<div style={{ marginBottom: "40px" }}>
                                                    <div onClick={onShowLogs} className="Logs-show-style">Logs
                                                        <span className="cursor hover-style" title="Hide / Show Logs" style={{ paddingRight: "20px", float: "right" }}><FontAwesomeIcon icon={!ShowLogs ? faPlus : faMinus} /></span></div>
                                                    {ShowLogs && (<div className="m-3" style={{ overflow: "auto" }}>
                                                        <table className="table table-striped table-bordered align-center">
                                                            <thead>
                                                                <tr>
                                                                    <th>SI No.</th>
                                                                    <th>Amount</th>
                                                                    <th style={{ width: "40%" }}>Remarks</th>
                                                                    <th>Date</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {SelectedQuotes.QuoteLogs.map((logs, index) => (
                                                                    <tr className="border-bottom" key={logs + "_" + index}>
                                                                        <td>
                                                                            <div style={{ padding: "0 20px" }} className="align-center">{index + 1}</div>
                                                                        </td>
                                                                        <td>
                                                                            <div>{logs.Amount}</div>
                                                                        </td>
                                                                        <td style={{ display: "flex", justifyContent: "center" }}>
                                                                            <div title={logs.Remarks} style={{
                                                                                overflow: "hidden",
                                                                                textOverflow: "ellipsis", whiteSpace: "nowrap", width: "250px"
                                                                            }}>{logs.Remarks}</div>
                                                                        </td>
                                                                        <td>
                                                                            <div className="align-center">{moment(logs.CreatedDate).local().format("DD/MM/YYYY hh:mm:ss A")}</div>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>)}
                                                </div>)}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>)}
                        {IntServDlvrFlag === 1 && (<div className="row">
                            <div className="col-md-12 col-12">
                                {SelectedDlvrs._id !== undefined && (
                                    <div className="card">
                                        <div className="card-body p-0">
                                            <div style={{ display: "flex", justifyContent: "space-between" }} className="card-title p-1 m-0 border-bottom">
                                                <h4 style={{ paddingLeft: "1rem" }}>Summary</h4>
                                                <div className='d-flex'>
                                                    {SelectedDlvrs.Status === 2 && (<div className='text-center pt-1' style={{ fontSize: "1.1rem", paddingRight: "10px", color: "orange" }}>
                                                        In progress...
                                                    </div>)}
                                                    {(DlvrsType === 1 && SelectedDlvrs.Status === 2) && (<span className="cursor" title="Complete" style={{
                                                        fontSize: "22px", color: "green",
                                                        paddingRight: "10px"
                                                    }} onClick={() => OnDlvrComplete(SelectedDlvrs._id)}>
                                                        <FontAwesomeIcon icon={faThumbsUp} /></span>)}
                                                    {(DlvrsType === 1 && SelectedDlvrs.Status < 2) && (<span className="cursor" title="Approve" style={{
                                                        fontSize: "22px", color: "green",
                                                        paddingRight: "10px"
                                                    }} onClick={() => OnDlvrApprove(SelectedDlvrs._id)}>
                                                        <FontAwesomeIcon icon={faCheck} /></span>)}
                                                    {(SelectedDlvrs.Status !== 2 && SelectedDlvrs.Status !== 3) && (<span className="cursor" title="Discard" style={{
                                                        fontSize: "22px", color: "red",
                                                        paddingRight: "10px"
                                                    }} onClick={() => OnDlvrDiscard(SelectedDlvrs._id)}>
                                                        <FontAwesomeIcon icon={faTimes} /></span>)}
                                                    {SelectedDlvrs.Status === 3 && (<div className='text-center' style={{ fontSize: "1.1rem", paddingRight: "5px", color: "green" }}>
                                                        Completed
                                                        <span title="click to close..." className='cursorpointer' onClick={() => OnDlvrClose(SelectedDlvrs._id)} style={{ float: "right" }}><FontAwesomeIcon icon={faThumbsUp}></FontAwesomeIcon></span>
                                                        <div style={{ fontSize: "16px", color: "#aaa" }}>
                                                            {moment(SelectedDlvrs.updatedAt).local().format("DD/MM/YYYY hh:mm:ss A")}</div>
                                                    </div>)}
                                                </div>
                                            </div>
                                            <div className="card-text p-1">
                                                <div className="row" style={{ margin: "0 10px 5px 10px" }}>
                                                    <div className="col-md-9 col-12" style={{ display: "flex", paddingLeft: "1rem", alignItems: "center" }}>
                                                        <div>
                                                            {LogoImage && (
                                                                <img className="companylogoStyle" alt="Org Logo" width="120" height="120" src={LogoImage}></img>)}
                                                        </div>
                                                        {SelectedDlvrs.Organization && SelectedDlvrs.Organization.length > 0 &&
                                                            (<div className="p-2" style={{ flex: "2" }}>
                                                                <h5>MFI {SelectedDlvrs.Organization[0].City}</h5>
                                                                <i><h6>{SelectedDlvrs.Organization[0].Name}</h6></i>
                                                                <i><h6>Ph No. : {SelectedDlvrs.Organization[0].Contact}</h6></i>
                                                            </div>)}
                                                    </div>
                                                    <div className="col-md-3 col-12 p-2 text-uppercase" style={{ textAlign: "center", paddingLeft: "5px" }}>
                                                        <h5 className="p-1" style={{ backgroundColor: "rgb(51, 153, 255)", color: "white", borderRadius: "20px" }}>
                                                            <span>CFT - {SelectedDlvrs.TotalCFT}
                                                            </span></h5>
                                                        <h6>
                                                            <div><u>Job ID</u></div>
                                                            <div style={{ fontWeight: "600" }}>
                                                                {`${SelectedDlvrs.JobID}_${moment(SelectedDlvrs.createdAt).local().format("DDMMYYYY")}`}
                                                            </div>
                                                        </h6>
                                                    </div>
                                                </div>
                                                {SelectedDlvrs && (<div className='row p-0 m-0 text-center d-flex justify-content-center'>
                                                    <div className='col-md-2 DlvrHighlight m-1'>Packages : <span >{SelectedDlvrs.TotalPackages}</span></div>
                                                    <div className='col-md-2 DlvrHighlight m-1'>HMS : <span style={{ color: (SelectedDlvrs.HardmenRequired === 1 ? "green" : "red") }}>
                                                        <FontAwesomeIcon icon={(SelectedDlvrs.HardmenRequired === 1 ? faCheck : faTimes)}></FontAwesomeIcon></span></div>
                                                    <div className='col-md-3 DlvrHighlight m-1'>Local Settling : <span style={{ color: (SelectedDlvrs.LocalSettling === 1 ? "green" : "red") }}>
                                                        <FontAwesomeIcon icon={(SelectedDlvrs.LocalSettling === 1 ? faCheck : faTimes)}></FontAwesomeIcon></span></div>
                                                    <div className='col-md-2 DlvrHighlight m-1'>WareHouse : <span style={{ color: (SelectedDlvrs.WareHouseRequired === 1 ? "green" : "red") }}>
                                                        <FontAwesomeIcon icon={(SelectedDlvrs.WareHouseRequired === 1 ? faCheck : faTimes)}></FontAwesomeIcon></span></div>
                                                    <div className='col-md-2 DlvrHighlight m-1'>Floors : <span >{SelectedDlvrs.FloorNumber === 0 ? "Ground" : SelectedDlvrs.FloorNumber}</span></div>
                                                    <div className='col-md-2 DlvrHighlight m-1'>Lift : <span style={{ color: (SelectedDlvrs.LiftAvailable === 1 ? "green" : "red") }}>
                                                        <FontAwesomeIcon icon={(SelectedDlvrs.LiftAvailable === 1 ? faCheck : faTimes)}></FontAwesomeIcon></span></div>
                                                    <div className='col-md-2 DlvrHighlight m-1'>Man Power : <span >{SelectedDlvrs.TotalManPower}</span></div>
                                                </div>)}
                                                <div className="p-2 align-center">
                                                    <h6 title={SelectedDlvrs.Remarks} style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}><i>"{SelectedDlvrs.Remarks}"</i></h6>
                                                </div>
                                                <div className="sourceDest-style">
                                                    <h5>{SelectedDlvrs.OriginCity}</h5>
                                                    <h5>{SelectedDlvrs.DestCity}</h5>
                                                </div>
                                                <div onClick={onShowAdditionalInfo} className="cursor Logs-show-style">Additional Info
                                                    <span className="cursor hover-style" title="Hide / Show Logs"
                                                        style={{ paddingRight: "20px", float: "right" }}>
                                                        <FontAwesomeIcon icon={!DlvrAdditionalInfo ? faPlus : faMinus} />
                                                    </span>
                                                </div>
                                                {DlvrAdditionalInfo && (<div className='p-1'>
                                                    <table className='table'>
                                                        <tbody>
                                                            <tr>
                                                                <td className='text-right'><span className='pr-2' style={{ fontWeight: "600" }}>Customer Name :</span></td>
                                                                <td>{SelectedDlvrs.DestCustomerName}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ width: "250px" }} className='text-right'><span className='pr-2' style={{ fontWeight: "600" }}>Dest Address :</span></td>
                                                                <td style={{ width: "70%" }}>{`${SelectedDlvrs.DestAddress}, ${SelectedDlvrs.DestCity}, ${SelectedDlvrs.DestState}, 
                                                    ${SelectedDlvrs.DestCountry}, ${SelectedDlvrs.DestPinCode}`}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className='text-right'><span className='pr-2' style={{ fontWeight: "600" }}>Customer Contact :</span></td>
                                                                <td>{SelectedDlvrs.DestContact}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className='text-right'><span className='pr-2' style={{ fontWeight: "600" }}>Truck Number :</span></td>
                                                                <td>{SelectedDlvrs.TrackingLink === "" ? (<span>{SelectedDlvrs.TruckNumber}</span>) :
                                                                    (<><a target='_blank' rel="noopener noreferrer" href={SelectedDlvrs.TrackingLink}>
                                                                        {SelectedDlvrs.TruckNumber}
                                                                    </a>
                                                                        <span className='ml-4 mr-2'><FontAwesomeIcon icon={faArrowLeft}></FontAwesomeIcon></span>
                                                                        <span>Track your shipment here...</span></>)}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className='text-right'><span className='pr-2' style={{ fontWeight: "600" }}>Driver Contact :</span></td>
                                                                <td>{SelectedDlvrs.DriverContact}</td>
                                                            </tr>
                                                            {SelectedDlvrs && SelectedDlvrs.DeliveryDate && (<tr>
                                                                <td className='text-right'><span className='pr-2' style={{ fontWeight: "600" }}>Tent. Delivery Date :</span></td>
                                                                <td>{moment(SelectedDlvrs.DeliveryDate).local().format("DD/MM/YYYY")}</td>
                                                            </tr>)}
                                                        </tbody>
                                                    </table>
                                                </div>)}
                                                <div>
                                                    {(DlvrsType === 1 && SelectedDlvrs.Status >= 2) && (<div onClick={onShowDlvrReply} className="cursor Logs-show-style">Delivery Reply
                                                        <span className="hover-style" title="Hide / Show Logs"
                                                            style={{ paddingRight: "20px", float: "right" }}>
                                                            <FontAwesomeIcon icon={!DlvrReply ? faPlus : faMinus} />
                                                        </span>
                                                    </div>)}
                                                    {DlvrReply && (<div style={{ marginBottom: "5px" }}><div className="text-field">
                                                        <input placeholder="" name="Amount" value={AddDlvrReply.Amount ? AddDlvrReply.Amount : 0}
                                                            onChange={(e) => onDlvrNumberChange(e)}
                                                            type="number"></input>
                                                        <span >Amount<span className="mandatoryStar">*</span></span>
                                                    </div>
                                                        <div className="text-field">
                                                            <textarea placeholder="" name="Remarks" rows="3"
                                                                value={AddDlvrReply.Remarks ? AddDlvrReply.Remarks : ""}
                                                                onChange={(e) => onDlvrTextChange(e)}></textarea>
                                                            <span>Remarks</span>
                                                        </div>
                                                        <div className="text-field">
                                                            <input type="file" disabled title='Coming Soon...' className='p-3'></input>
                                                            <span>Uploads</span>
                                                        </div>
                                                        <div className="buttonresponsive align-right">
                                                            <button onClick={() => onDlvrReplySave(SelectedDlvrs._id)} className={`btn btn-Save ${CurrentTheme}Focus`}>Reply</button>
                                                        </div>
                                                    </div>)}
                                                </div>
                                            </div>
                                            {(SelectedDlvrs && SelectedDlvrs.DeliveryLogs &&
                                                SelectedDlvrs.DeliveryLogs.length > 0) && (<div style={{ marginBottom: "10px" }}>
                                                    <div onClick={onShowLogs} className="cursor Logs-show-style">Logs
                                                        <span className="cursor hover-style" title="Hide / Show Logs" style={{ paddingRight: "20px", float: "right" }}><FontAwesomeIcon icon={!ShowLogs ? faPlus : faMinus} /></span></div>
                                                    {ShowLogs && (<div className="m-3" style={{ overflow: "auto" }}>
                                                        <table className="table table-striped table-bordered align-center">
                                                            <thead>
                                                                <tr>
                                                                    <th>SI No.</th>
                                                                    <th>Amount</th>
                                                                    <th style={{ width: "40%" }}>Remarks</th>
                                                                    <th>Date</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {SelectedDlvrs.DeliveryLogs.map((logs, index) => (
                                                                    <tr className="border-bottom" key={logs + "_" + index}>
                                                                        <td>
                                                                            <div style={{ padding: "0 20px" }} className="align-center">{index + 1}</div>
                                                                        </td>
                                                                        <td>
                                                                            <div>{logs.Amount}</div>
                                                                        </td>
                                                                        <td style={{ display: "flex", justifyContent: "center" }}>
                                                                            <div title={logs.Remarks} style={{
                                                                                overflow: "hidden",
                                                                                textOverflow: "ellipsis", whiteSpace: "nowrap", width: "250px"
                                                                            }}>{logs.Remarks}</div>
                                                                        </td>
                                                                        <td>
                                                                            <div className="align-center">{moment(logs.CreatedDate).local().format("DD/MM/YYYY hh:mm:ss A")}</div>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>)}
                                                </div>)}
                                            <div style={{ marginBottom: "10px" }}>
                                                {DlvrsType === 1 && (<div onClick={onShowDlvrTerms} className="cursor Logs-show-style">
                                                    Terms and Conditions
                                                    <span className="cursor hover-style" title="Shows Terms and Conditions"
                                                        style={{ paddingRight: "20px", float: "right" }}>
                                                        <FontAwesomeIcon icon={!DlvrTerms ? faPlus : faMinus} />
                                                    </span>
                                                </div>)}
                                                {DlvrTerms && (<div className='mt-2' style={{ marginBottom: "5px" }}>
                                                    <ul>
                                                        <li>
                                                            Read all the requirements properly before accepting and starting the work. If there are any doubts then they need to coordinate with the requesting partner.
                                                        </li>
                                                        <li>
                                                            Before arranging the crew, you need to confirm the timings with the customer and the driver.
                                                        </li>
                                                        <li>
                                                            If you are needed to give extra service that increases the expenses/manpower , you need to get it approved from the requesting partner before proceeding.
                                                        </li>
                                                    </ul>
                                                </div>)}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>)}
                    </div>
                </div >
            </div >
            <div id="SelectedSurvey" className="modal" style={{ display: displayPartnerSurveyView }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                        <span style={{ marginLeft: "5px", padding: "5px" }}>Survey View</span>
                        <span className="close" onClick={hideSurveyView}>&times;</span>
                    </div>

                    <table className="table tableTDWidthStyle">
                        <tbody>
                            <tr className="align-center">
                                <td>
                                    <div className="text-field" style={{ margin: "0" }}>
                                        <input readOnly={true} placeholder="" value={SelectedPartnerSurvey.Name || ""}
                                            type="text"></input>
                                        <span>Customer Name</span>
                                    </div>
                                </td>
                                <td>
                                    <div className="text-field" style={{ margin: "0" }}>
                                        <input readOnly={true} placeholder="" value={SelectedPartnerSurvey.CompanyName ? (SelectedPartnerSurvey.CompanyName === "" ? "-" : SelectedPartnerSurvey.CompanyName) : "-"}
                                            type="text"></input>
                                        <span>Company Name</span>
                                    </div>
                                </td>
                            </tr>
                            <tr className="align-center">
                                <td>
                                    <div className="text-field" style={{ margin: "0" }}>
                                        <textarea style={{ resize: "none" }} rows="2" readOnly={true} placeholder="" value={SelectedPartnerSurvey.OriginAddress + ", " +
                                            SelectedPartnerSurvey.OriginCity + ", " + SelectedPartnerSurvey.OriginState + ", " +
                                            SelectedPartnerSurvey.OriginCountry + ", " + SelectedPartnerSurvey.OriginPincode}
                                            type="text"></textarea>
                                        <span>Origin Address</span>
                                    </div>
                                </td>
                                <td>
                                    <div className="text-field" style={{ margin: "0" }}>
                                        <textarea style={{ resize: "none" }} rows="2" readOnly={true} placeholder="" value={SelectedPartnerSurvey.DestinationAddress + ", " +
                                            SelectedPartnerSurvey.DestinationCity + ", " + SelectedPartnerSurvey.DestinationState + ", " +
                                            SelectedPartnerSurvey.DestinationCountry + ", " + SelectedPartnerSurvey.DestinationPincode}
                                            type="text"></textarea>
                                        <span>Dest. Address</span>
                                    </div>
                                </td>
                            </tr>
                            <tr className="align-center">
                                <td>
                                    <div className="text-field" style={{ margin: "0" }}>
                                        <input readOnly={true} placeholder="" value={SelectedPartnerSurvey.OriginFloor || ""}
                                            type="text"></input>
                                        <span>Origin Floor</span>
                                    </div>
                                </td>
                                <td>
                                    <div className="text-field" style={{ margin: "0" }}>
                                        <input readOnly={true} placeholder="" value={SelectedPartnerSurvey.DesinationFloor || ""}
                                            type="text"></input>
                                        <span>Dest. Floor</span>
                                    </div>
                                </td>
                            </tr>
                            <tr className="align-center">
                                <td>
                                    <div className="text-field" style={{ margin: "0" }}>
                                        <input readOnly={true} placeholder="" value={SelectedPartnerSurvey.PreferredPackingDate ? moment(SelectedPartnerSurvey.PreferredPackingDate).local().format("DD/MM/YYYY") : ""}
                                            type="text"></input>
                                        <span>Packing Date</span>
                                    </div>
                                </td>
                                <td>
                                    <div className="text-field" style={{ margin: "0" }}>
                                        <input readOnly={true} placeholder="" value={SelectedPartnerSurvey.PreferredMovingDate ? moment(SelectedPartnerSurvey.PreferredMovingDate).local().format("DD/MM/YYYY") : ""}
                                            type="text"></input>
                                        <span>Moving Date</span>
                                    </div>
                                </td>
                            </tr>
                            <tr className="align-center">
                                <td>
                                    <div className="text-field" style={{ margin: "0" }}>
                                        <input readOnly={true} placeholder="" value={SelectedPartnerSurvey.PreferredDeliveryDate ? moment(SelectedPartnerSurvey.PreferredDeliveryDate).local().format("DD/MM/YYYY") : ""}
                                            type="text"></input>
                                        <span>Delivery Date</span>
                                    </div>
                                </td>
                                <td colSpan="2">
                                    <div className="text-field" style={{ margin: "0" }}>
                                        <input readOnly={true} placeholder="" value={SelectedPartnerSurvey.IsInsured ? (SelectedPartnerSurvey.IsInsured === 1 ? SelectedPartnerSurvey.InsuranceAmount : "-") : "-"}
                                            type="text"></input>
                                        <span>Insurance Amount</span>
                                    </div>
                                </td>
                            </tr>
                            <tr className="align-center">
                                <td>
                                    <div className="text-field" style={{ margin: "0" }}>
                                        <input readOnly={true} placeholder="" value={(SelectedPartnerSurvey.IBAApproval && SelectedPartnerSurvey.IBAApproval === 0) ? "Yes" : "No"}
                                            type="text"></input>
                                        <span>IBA Approved</span>
                                    </div>
                                </td>
                                <td>
                                    <div className="text-field" style={{ margin: "0" }}>
                                        <input readOnly={true} placeholder="" value={SelectedPartnerSurvey.IsGSTAvailable === 1 ? SelectedPartnerSurvey.GSTNumber : "-"}
                                            type="text"></input>
                                        <span>GST</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ textAlign: "right" }} colSpan="2">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <button type="button" className="btn btn-default" onClick={hideSurveyView}>Close</button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div id="SelectedSurvey" className="modal" style={{ display: displayPartnerGoodsView }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                        <span style={{ marginLeft: "5px", padding: "5px" }}>Goods View</span>
                        <span className="close" onClick={hideGoodsView}>&times;</span>
                    </div>
                    <div style={{ height: "60vh", overflow: "auto", overflowX: "hidden" }}>
                        <table className="table table-striped align-center">
                            <thead>
                                <tr>
                                    <th style={{ backgroundColor: "white", zIndex: "0" }}>Name</th>
                                    <th style={{ backgroundColor: "white", zIndex: "0" }}>Remarks</th>
                                    <th style={{ backgroundColor: "white", zIndex: "0" }}>Quantity</th>
                                    <th style={{ backgroundColor: "white", zIndex: "0" }}>CFT</th>
                                    <th style={{ backgroundColor: "white", zIndex: "0" }}>Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {SelectedPartnerGoods.map((survey, index) => (
                                    <tr key={index}>
                                        <td>{survey.Name}</td>
                                        <td style={{ width: "300px", wordBreak: "break-word" }}>{survey.Remarks}</td>
                                        <td>{survey.Quantity}</td>
                                        <td>{survey.CFTValue}</td>
                                        <td>{parseInt(survey.Quantity) * parseInt(survey.CFTValue)}</td>
                                    </tr>
                                ))}
                                <tr style={{ fontSize: "1.3rem" }}>
                                    <td colSpan="4">Total CFT / Vehicle Load</td>
                                    <td>{TotalPartnerCFT} / {PartnerVehicleRequired}</td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "right" }} colSpan="5">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <button type="button" className="btn btn-default" onClick={hideGoodsView}>Close</button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div id="myModalReward" className="modal" style={{ display: displayAddRewardModel }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                        <span style={{ marginLeft: "5px", padding: "5px" }}>Transfer Wallet Points</span>
                        <span className="close" onClick={hideRewardAdd}>&times;</span>
                    </div>
                    <div className="row" style={{ marginTop: "10px", marginBottom: "10px" }}>
                        <div className="col-md-12 col-sm-12">
                            <table className="table">
                                <tbody>
                                    <tr>
                                        <td>
                                            <h5>Points<span className="mandatoryStar">*</span></h5>
                                        </td>
                                        <td>
                                            <input type="number" min="0.00" step="any" name="Points"
                                                className="form-control"
                                                onChange={e => onNumberChange(e)}
                                                value={AddRewardData.Points}></input>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><h5>Transfer To<span className="mandatoryStar">*</span></h5></td>
                                        <td>
                                            <div>
                                                <Select isClearable={true} isSearchable={true} placeholder="Select Partner"
                                                    options={TransferUsers}
                                                    onChange={OnTransferUserChange}></Select>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <h5>Remarks<span className="mandatoryStar">*</span></h5>
                                        </td>
                                        <td>
                                            <textarea
                                                onChange={e => onTextChange(e)}
                                                rows="2"
                                                className="form-control" name="Remarks"
                                                value={AddRewardData.Remarks}></textarea>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="2" style={{ textAlign: "right" }}>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <button type="button" style={{ fontSize: "1.4rem" }} className={`btn btn-Save ${CurrentTheme}Focus`} onClick={AddRewardDetails}>Save</button>
                                                    <button type="button" className="btn btn-default" onClick={hideRewardAdd}>Close</button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div id="myModalBorrowRequest" className="modal" style={{ display: displayBorrowRequest }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                        <span style={{ marginLeft: "5px", padding: "5px" }}>Request Wallet Points</span>
                        <span className="close" onClick={hideBorrowRequestAdd}>&times;</span>
                    </div>
                    <div className="row" style={{ marginTop: "10px", marginBottom: "10px" }}>
                        <div className="col-md-12 col-sm-12">
                            <table className="table">
                                <tbody>
                                    <tr>
                                        <td>
                                            <h5>Points<span className="mandatoryStar">*</span></h5>
                                        </td>
                                        <td>
                                            <input type="number" min="0.00" step="any" name="Points"
                                                className="form-control"
                                                onChange={e => onNumberChange(e)}
                                                value={AddRewardData.Points}></input>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><h5>Request To<span className="mandatoryStar">*</span></h5></td>
                                        <td>
                                            <div>
                                                <Select isClearable={true} isSearchable={true} placeholder="Select Partner"
                                                    options={TransferUsers}
                                                    onChange={OnTransferUserChange}></Select>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><h5>Request Type<span className="mandatoryStar">*</span></h5></td>
                                        <td>
                                            <div>
                                                <Select isClearable={true} isSearchable={true} placeholder="Request Type"
                                                    options={RequestType}
                                                    onChange={onRequestTypeChange}></Select>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <h5>Remarks<span className="mandatoryStar">*</span></h5>
                                        </td>
                                        <td>
                                            <textarea
                                                onChange={e => onTextChange(e)}
                                                rows="2"
                                                className="form-control" name="Remarks"
                                                value={AddRewardData.Remarks}></textarea>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="2" style={{ textAlign: "right" }}>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <button type="button" style={{ fontSize: "1.4rem" }} className={`btn btn-Save ${CurrentTheme}Focus`} onClick={AddBorrowRequestDetails}>Save</button>
                                                    <button type="button" className="btn btn-default" onClick={hideBorrowRequestAdd}>Close</button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {UserDirShow && (<UserDirectory hideUserDirView={hideUserDirView}></UserDirectory>)}
            {UserAlertShow && (<UserAlerts hideUserAlertView={hideUserAlertView}></UserAlerts>)}
        </div >
    );
};

export default PartnerDashBoard;